import React, { useState, useEffect } from "react";
import { Modal, Col, Row } from "react-bootstrap";
import IcX from "../Svg/IcX";
import Button from "../Button";
import styles from "./style.module.css";
import Slct from "../Slct";
import useFormat from "../../hooks/utils/useFormat";
import api from "../../services/api";
import useWrapper from "../../hooks/useWrapper";
import { toast } from "react-toastify";
import Results from "../Results";

export default function ModalProductTrainee(props) {
  const { show, closeModal, productPreLoad: product_pre_load, has_amount = 0 } = props;
  const { formatReal } = useFormat();
  const { config, me, reloadMe } = useWrapper();
  const [product, setproduct] = useState();
  const [loadingRequest, setloadingRequest] = useState(false);
  const [successResult, setsuccessResult] = useState();

  useEffect(() => {
    if (product_pre_load) {
      setsuccessResult(null);
      let _quotas = [];
      for (let i = 0; i < product_pre_load.quantity - has_amount; i++) {
        _quotas.push({ value: i + 1, label: i + 1 });
      }
      setproduct({
        amount: 1,
        quotas: _quotas,
        price: (product_pre_load.value || 0) + (product_pre_load.contribution_value || 0),
        convenience_fee: product_pre_load.convenience_fee,
        commercial_id: product_pre_load.commercial_id,
        cost_center_id: product_pre_load.cost_center_id,
        expense_plan_id: product_pre_load.expense_plan_id,
        expense_id: product_pre_load.expense_id,
        id: product_pre_load.id,
      });
    }
  }, [product_pre_load, has_amount]);

  useEffect(() => {
    if (product?.amount && product_pre_load) {
      setproduct(p => ({
        ...p,
        price: (product_pre_load.value || 0) + (product_pre_load.contribution_value || 0),
      }));
    }
  }, [product?.amount, product_pre_load]);

  const submitProduct = async () => {
    try {
      setloadingRequest(true);
      let tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 3);

      const _value = (product?.price || 0) * (product?.amount || 0) + (product?.convenience_fee || 0);

      const { data: success_result } = await api.post(
        "trainee/create-payment",
        {
          method_payment: "boleto",
          type_payment: "parcelado",
          value: _value,
          value_raw: _value,
          due_date: tomorrow,
          description: "",
          quotas: 1,
          total_quotas: 1,
          tax: product?.convenience_fee || 0,
          tax_description: "Taxa de conveniência",
          entry: false,
          editable: false,
          commercial_id: product?.commercial_id,
          trainee_id: me?.id,
          cost_center_id: product?.cost_center_id,
          expense_plan_id: product?.expense_plan_id,
          expense_id: product?.expense_id,
          status: "nao-gerado",
          custom_payment_id: product?.id,
          aditional_information: product?.amount,
        },
        config,
      );
      setsuccessResult(success_result);
    } catch (__error) {
      toast.error("Erro ao tentar solicitar produto.");
      console.log("__error", __error);
    } finally {
      setloadingRequest(false);
      reloadMe();
      closeModal();
      toast.success("Produto solicitado com sucesso!");
    }
  };

  return (
    <Modal size="md" show={show} onHide={closeModal} centered>
      <Modal.Header>
        <div as="label" className="d-flex w-100">
          <h2 className="page-title">{product_pre_load?.name}</h2>
        </div>
        <button className={styles.closeModal} onClick={closeModal}>
          <IcX />
        </button>
      </Modal.Header>
      {!!successResult ? (
        <Modal.Body>
          <p>
            <a href={successResult?.boleto_url || "#"} target="_blank" rel="noreferrer">
              Clique aqui
            </a>{" "}
            para acessar o boleto. Você também pode acessá-lo na página do seu <b>Financeiro</b>.
          </p>
        </Modal.Body>
      ) : (
        <Modal.Body>
          <Row className="mb-3">
            <Col>
              <p className="m-0 op-5">{product_pre_load?.description}</p>
            </Col>
          </Row>
          {has_amount < product_pre_load?.quantity ? (
            <>
              <Row className="mb-3">
                <Col>
                  <label>Quantidade</label>
                  <Slct
                    options={product?.quotas || []}
                    value={product?.amount}
                    onChange={__e => {
                      setproduct({
                        ...product,
                        amount: __e.value,
                      });
                    }}
                    placeholder="..."
                  />
                </Col>
              </Row>
              <Row className="text-right">
                <Col md={{ span: 8, offset: 4 }}>
                  <Results
                    rows={[
                      {
                        label: "Unidade",
                        value: formatReal(product?.price || 0),
                        type: "dark",
                      },
                      ...(!!product?.convenience_fee
                        ? [
                            {
                              label: "Taxa de Conveniência",
                              value: formatReal(product?.convenience_fee || 0),
                            },
                          ]
                        : []),
                      {
                        label: <b>Total</b>,
                        value: (
                          <b>
                            {formatReal((product?.price || 0) * (product?.amount || 0) + product?.convenience_fee || 0)}
                          </b>
                        ),
                        type: !!product?.convenience_fee ? "dark" : "",
                      },
                    ]}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <p>
              <b>Você já comprou/solicitou a quantidade máxima de produtos disponíveis.</b>
            </p>
          )}
        </Modal.Body>
      )}
      {!successResult && (
        <Modal.Footer>
          {has_amount < product_pre_load?.quantity ? (
            <Button
              color="primary"
              onClick={() => {
                submitProduct();
              }}
              loading={loadingRequest}
            >
              Comprar
            </Button>
          ) : (
            <Button
              color="primary"
              onClick={() => {
                closeModal();
              }}
              loading={loadingRequest}
            >
              Entendi
            </Button>
          )}
        </Modal.Footer>
      )}
    </Modal>
  );
}
